import type { AchordData } from 'src/app';

export interface ChatComponent {
	component: AchordData.EntryComponent;
	props: AchordData.GenericEntry;
}


export class Achord {
	private activeChannel: string;
	private onlineProfiles: AchordData.Profile[] = [];
	private channels: Record<string, ChatComponent[]> = {};

	constructor(activeChannel: string) {
		this.activeChannel = activeChannel;
	}

	changeChannel(channel: string) {
		this.activeChannel = channel;
	}

	createChannel(name: string) {
		this.channels[name] = [];
	}

	insert(component: AchordData.EntryComponent, props: AchordData.GenericEntry, channel = this.activeChannel): void {
		this.channels[channel].push({
			component,
			props
		});
	}

	remove(entry: AchordData.GenericEntry) {
		this.channels[this.activeChannel] = this.channels[this.activeChannel].filter((e) => e.props !== entry);
	}

	get() {
		return this.channels[this.activeChannel];
	}

	last(): AchordData.Message | undefined {
		const channel = this.channels[this.activeChannel];
		if (channel.length === 0) {
			return;
		}

		for (let lastIndex = channel.length - 1; lastIndex >= 0; lastIndex--) {
			if (channel[lastIndex].props.protected !== true ) {
				return channel[lastIndex].props as AchordData.Message;
			}
		}
	}

	lastMessage(): string {
		const entry = this.last()
		return entry?.content || "";
	}

	getChannels() {
		return Object.keys(this.channels);
	}

	setOnline(online: AchordData.Profile[]) {
		this.onlineProfiles = online;
	}
	online() {
		return this.onlineProfiles;
	}
}